import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PacoteCampanhaMultiselectComponent } from './pacote-campanha-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PacoteCampanhaMultiselectComponent
    ],
    exports: [
        PacoteCampanhaMultiselectComponent
    ]
})
export class PacoteCampanhaMultiselectModule { }
